import { gql } from '@apollo/client';

export const GENERATE_PAYMENTS = gql`
mutation GeneratePayments($month: String, $year: String, $shouldNotifyPublisher: Boolean) {
  generatePayments(month: $month, year: $year, shouldNotifyPublisher: $shouldNotifyPublisher) {
    count
  }
}
`;
